const actionTypes = {
    SET_SELECTORGRID_STATE: "SET_SELECTORGRID_STATE"
};

export const setSelectorGridState = (selectorgrid, state) => {
    return {type: actionTypes.SET_SELECTORGRID_STATE, selectorgrid, state}
}

export default actionTypes;